/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { UserDetails } from './user-details.model';

export enum FinalizationType {
  ORG_SAML_LOGIN_REQUIRED = 'ORG_SAML_LOGIN_REQUIRED',
  AUTH_SUCCESS = 'AUTH_SUCCESS',
}

export interface LoginFinalizationResponse {
  accessToken?: string;
  message?: string;
  type?: FinalizationType;
  redirect?: string;
  user: UserDetails;
}

export interface TokenValidationResponse {
  email: string;
  affiliationSelectionEnabled: boolean;
}

export type MagicLinkResponseType =
  | 'AUTH_SUCCESS'
  | 'TOKEN_NOT_FOUND'
  | 'TOKEN_EXPIRED'
  | 'TOKEN_ALREADY_USED'
  | 'ORG_MISMATCH'
  | 'ACCOUNT_NOT_VERIFIED'
  | 'ORG_INACTIVE'
  | 'AUTH_ERROR';

export interface MagicLinkLoginResponse {
  accessToken?: string;
  message?: string;
  type: MagicLinkResponseType;
  redirect?: string;
  user?: UserDetails;
}
